'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const Template = require('communication/ui/counter/counter.hbs');


module.exports = Mn.View.extend({
    template: Template,

    className: 'communication-counter-view',

    initialize: function() {
        this.model = new Backbone.Model({});
        this.model.set('badge', this.getOption('badge'));

        this.listenBadgeChange();
    },

    templateContext: function() {
        return {
            icon: this.getIcon(),
            badgeContent: this.getBadgeContent(),
            unread: this.hasUnread(),
        };
    },

    onRender: function() {
        if (this.getBadge()) {
            this.$el.removeClass('hide');
        } else {
            this.$el.addClass('hide');
        }

        if (this.hasUnread()) {
            this.$el.addClass('has-unread-indicator');
        } else {
            this.$el.removeClass('has-unread-indicator');
        }

        return this;
    },

    onChangeBadge: function() {
        this.render();
    },

    getIcon: function() {
        return this.getOption('icon');
    },

    getBadge: function () {
        if (!this.model) {
            return null;
        }
        return this.model.get('badge');
    },

    getBadgeContent: function() {
        if (!this.getBadge() || !this.getBadge().content) {
            return null;
        }

        return this.getBadge().content();
    },

    hasUnread: function() {
        if (!this.getBadge() || !this.getBadge().hasUnread) {
            return null;
        }

        return this.getBadge().hasUnread();
    },

    listenBadgeChange: function () {
        if (!this.getBadge() || !this.getBadge().listen) {
            return null;
        }

        return this.getBadge().listen(_.bind(this.onChangeBadge, this));
    }
});



// WEBPACK FOOTER //
// ./communication/ui/counter/counter.js